import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { MAX_BID_CHANGES } from '../../constants/tableTypes'

const initialState = {
  data: [],
}

const maxBidHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case `REPLACE_TABLE_USER_INFO_${MAX_BID_CHANGES}`:
      return reducers.dataTable.replaceTableUsersInfoReducer(
        MAX_BID_CHANGES,
        state,
        action
      )
    default:
      return reducers.auditTable.auditTableReducer(MAX_BID_CHANGES)(
        state,
        action
      )
  }
}

export default combineReducers({
  data: maxBidHistoryReducer,
  tableInfo: reducers.auditTableColumnDefinitions(MAX_BID_CHANGES),
  users: (state, action) =>
    reducers.dataTable.mappedUsersReducer(MAX_BID_CHANGES, state, action),
})
